import { render, staticRenderFns } from "./ProjectLogs.vue?vue&type=template&id=dfdbea38&scoped=true"
import script from "./ProjectLogs.vue?vue&type=script&lang=js"
export * from "./ProjectLogs.vue?vue&type=script&lang=js"
import style0 from "./ProjectLogs.vue?vue&type=style&index=0&id=dfdbea38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdbea38",
  null
  
)

export default component.exports